import { Box, Button, Container, Typography } from '@mui/material'
import { useContext } from 'react'
import { HotelContext } from '../contexts/HotelContext'
import { useQuery } from '@tanstack/react-query'
import { OverlayLoader } from '../components/Loader'
import { getCheckInReservation } from '../apis/checkinApis'
import { BackButton } from '../components/BackButton'
import { DateTimeFormats } from '../common/constants'
import { DateTime } from 'luxon'
import { useNavigate } from 'react-router'

const CardKeySucessPage = () => {
  const { reservation, hotel, clearReservationToken } = useContext(HotelContext)
  const { data, isLoading } = useQuery({
    queryKey: ['getCheckInReservation', hotel.hotelId, reservation.id],
    queryFn: () => getCheckInReservation(hotel.hotelId, reservation.id),
  })
  const navigate = useNavigate()

  const handleSubmit = () => {
    clearReservationToken()
    navigate(`/hotel/${hotel.hotelId}`)
  }

  if (isLoading) {
    return <OverlayLoader />
  }

  return (
    <Container maxWidth="md" style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <BackButton to={`/hotel/${hotel.hotelId}/checkin`} />
      <Box mt={4} mb={1}>
        <Typography
          color={(theme) => theme.palette.primary.main}
          gutterBottom
          textAlign="center"
          variant="h4"
          fontWeight="600">
          Tạo thẻ phòng thành công
        </Typography>
      </Box>
      <Container style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', maxWidth: '650px' }}>
        <Box>
          <Typography gutterBottom>
            <span>Quý khách vui lòng dùng thẻ để mở phòng:</span>
          </Typography>
          <Typography gutterBottom>
            <span>Số phòng: </span>
            <b>{data.ezcloud?.roomName}</b>
          </Typography>
          <Typography gutterBottom>
            <span>Khách sạn: </span>
            <b>{hotel.hotelName}</b>
          </Typography>
          <Typography gutterBottom>
            <span>Nhận phòng: </span>
            <b>{DateTime.fromISO(data.from).toFormat(DateTimeFormats.FULL)}</b>
          </Typography>
          <Typography gutterBottom>
            <span>Trả phòng: </span>
            <b>{DateTime.fromISO(data.to).toFormat(DateTimeFormats.FULL)}</b>
          </Typography>
        </Box>
        <Box width="100%" mt={4}>
          <Button size="large" fullWidth variant="contained" onClick={handleSubmit}>
            <span>Xin cảm ơn</span>
          </Button>
        </Box>
      </Container>
    </Container>
  )
}

export default CardKeySucessPage
